export function normalizePhone(value) {
  const phone=String(value || '').normalize('NFKC')
    .replace(/[۰-۹]/g, digit => String(digit.charCodeAt(0) - 0x06f0))
    .replace(/[٠-٩]/g, digit => String(digit.charCodeAt(0) - 0x0660))
    .replace(/[\s\u200b-\u200f\u202a-\u202e\u2066-\u2069()\-]/g, '');
  return /^9\d{9}$/.test(phone)?'0'+phone:phone;
}
